module.exports = __webpack_public_path__ + "static/media/MultiBankTower.181896de.jpg";